













































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import Card from '@/components/material/Card.vue';
import DlgEditRecipient from '@/modules/newsletter/_components/DlgEditRecipient.vue';
import StatsCard from '@/components/material/StatsCard.vue';

@Component({
  components: {
    StatsCard,
    DlgEditRecipient,
    Card,
  },
  filters: {
    date(val: any) {
      if (!val) {
        return '-';
      }
      const date = new Date(val);
      return `${date.getDate()}.${date.getMonth() + 1}.${date.getUTCFullYear()}`;
    },
    datetime(val: any) {
      if (!val) {
        return '-';
      }
      const date = new Date(val);
      let hours = '' + date.getHours();
      hours = ('0' + hours).slice(-2);
      let minutes = '' + date.getMinutes();
      minutes = ('0' + minutes).slice(-2);

      return `${date.getDate()}.${date.getMonth() + 1}.${date.getUTCFullYear()} ${hours}:${minutes}`;
    },
    status(val: any) {
      switch (val) {
        case 'opened':
          return 'Geöffnet';
        case 'click':
          return 'Geklickt';
        case 'soft_bounce':
          return 'Soft Bounce';
        case 'unsubscribe':
          return 'Abgemeldet';
        case 'delivered':
          return 'Zugestellt';
      }
    },
  },
})
export default class CampaignStats extends Vue {
  @Prop(String) private readonly id!: string;

  @Action('campaigns/readStats') private readStats!: any;

  @Getter('campaigns/stats') private stats!: any;

  private loading: boolean = false;

  private notificationTypeFilter: string = 'all';

  private delivered: number = 0;
  private opened: number = 0;
  private openedUnique: number = 0;
  private clicked: number = 0;
  private bounced: number = 0;
  private unsubscribed: number = 0;

  private pagination: any = {
    sortBy: 'createdAt',
    descending: true,
    rowsPerPage: 25,
  };

  private headers: any[] = [
    {
      text: 'Email',
      align: 'left',
      value: 'address',
    },
    {
      text: 'Status',
      align: 'left',
      value: 'notificationType',
    },
    {
      text: 'Uhrzeit',
      align: 'left',
      value: 'createdAt',
    },
  ];

  private search: string = '';

  get statsList() {
    return this.stats.filter((stat: any) =>
      this.notificationTypeFilter !== 'all' ? (stat.notificationType === this.notificationTypeFilter) : true);
  }

  private async created() {
    this.loading = true;
    await this.readStats({id: this.id});

    this.opened = 0;
    this.openedUnique = 0;
    this.delivered = 0;
    this.bounced = 0;
    this.clicked = 0;
    this.unsubscribed = 0;

    const openers: any = [];

    this.stats.forEach((stat: any) => {
      switch (stat.notificationType) {
        case 'opened':
          this.opened++;

          if (openers.indexOf(stat.address) === -1) {
            this.openedUnique++;
            openers.push(stat.address);
          }

          break;
        case 'delivered':
          this.delivered++;
          break;
        case 'soft_bounce':
          this.bounced++;
          break;
        case 'click':
          this.clicked++;
          break;
        case 'unsubscribe':
          this.unsubscribed++;
          break;
        default:
          break;
      }


      if (stat.notificationType === 'opened') {
        this.opened++;
      }
      if (stat.notificationType === 'delivered') {
        this.opened++;
      }
    });

    this.loading = false;
  }
}
